//const BASE_URL = "http://35.212.163.94:8080/api";

export const NETWORK_ERROR = {
  data: { status: 404, message: "Network Error Occured!" }
};

/* Auth */
// export const LOGIN = (email,password)=>`/users/${email}/passwords/${password}`;
export const LOGIN='/user/login/email'
export const REGISTER = `/users`;
export const LOGOUT = `/logout`;
export const REFRESH_TOKEN='/user/refreshToken';

/* Roles */
export const ROLES = `/roles`;

/* Projects */
export const PROJECTS = `/projects`;
export const CREATE_PROJECT = `/projects/new`;
export const DELETE_PROJECT = `/projects/remove`;
export const UPDATE_PROJECT = `/projects/update`;
